"use strict";
export function orderMigrateLiquiditySteps(flow) {
  const steps = [];
  if (flow.permit) {
    steps.push(flow.permit);
  }
  steps.push(flow.migrate);
  return steps;
}
